import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PipeLineService } from 'src/app/private/services/pipeline.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { TrackingService } from 'src/app/private/services/tracking.service';


@Component({
  selector: 'app-create-new-pipeline',
  templateUrl: './create-new-pipeline.component.html',
  styleUrls: ['./create-new-pipeline.component.scss']
})
export class CreateNewPipelineComponent {

  @Output() close = new EventEmitter();
  @Input() formAction = 'Create';
  @Output() reload = new EventEmitter();
  @Input() updateData: any;
  @Input() selectedTab: any = 'lead';

  btnLoading = false;

  constructor(
    private localStorage: LocalStorageService,
    private api: PipeLineService,
    // private userApi: UsersService,
    private modalService: NgbModal,
    private toast: ToastrService,
    private cdr: ChangeDetectorRef,
    private tracker: TrackingService
  ) { }



  closeModal() {
    this.close.emit();
  }
  stages: any[] = [];
  selectedItems: any[] = [];
  dropdownSettings = {};
  ngOnInit() {

    if(this.selectedTab === 'deal'){
    this.stages = [
       {
        item_id: 'Closed Won', item_text: 'Closed Won',
        probability: 100,
        isDisabled: true
      },
      {
        item_id: 'Closed Lost', item_text: 'Closed Lost',
        probability: 0,
        isDisabled: true
      },
      {
        item_id: 'Qualification Needs', item_text: 'Qualification Needs',
        probability: 10
      },
      {
        item_id: 'Analysis Value', item_text: 'Analysis Value',
        probability: 25
      },
      {
        item_id: 'Proposition', item_text: 'Proposition',
        probability: 40
      },
      {
        item_id: 'Identity Decision Makers', item_text: 'Identity Decision Makers',
        probability: 50
      },
      {
        item_id: 'Proposal/Price Quote', item_text: 'Proposal/Price Quote',
        probability: 60
      },
      {
        item_id: 'Negotiation/Review', item_text: 'Negotiation/Review',
        probability: 75
      },
     
      {
        item_id: 'Closed Lost to Competition', item_text: 'Closed Lost to Competition',
        probability: 0
      },
      
    ];

    this.selectedItems = [
      { item_id: 'Closed Won', item_text: 'Closed Won', probability: 100, disabled: true },
      { item_id: 'Closed Lost', item_text: 'Closed Lost', probability: 0, disabled: true },
    ];
  }

    if(this.selectedTab === 'lead') {
     
      this.stages = [
       { item_id: 'Follow-up', item_text: 'Follow-up', isDisabled: true , probability: 20},
    { item_id: 'Completed', item_text: 'Completed', isDisabled: true , probability: 90},
    { item_id: 'Communicated', item_text: 'Communicated', isDisabled: true , probability: 50},
    { item_id: 'Pending', item_text: 'Pending', isDisabled: true , probability: 10},
        {
          item_id: 'New', item_text: 'New',
          probability: 10
        },
        {
          item_id: 'Active', item_text: 'Active',
          probability: 25
        },
        {
          item_id: 'Pipeline /Budgetary', item_text: 'Pipeline /Budgetary',
          probability: 40
        },
        {
          item_id: 'Contacted', item_text: 'Contacted',
          probability: 50
        },
        {
          item_id: 'Qualified', item_text: 'Qualified',
          probability: 60
        },
        {
          item_id: 'Converted', item_text: 'Converted',
          probability: 75
        },
        {
          item_id: 'Closed - Lost', item_text: 'Closed - Lost',
          probability: 0
        },
        {
          item_id: 'Closed - Won', item_text: 'Closed - Won',
          probability: 100
        },
      ];

      this.selectedItems = [
      { item_id: 'Follow-up', item_text: 'Follow-up' , probability: 20, disabled: true},
      { item_id: 'Completed', item_text: 'Completed' , probability: 90, disabled: true},
      { item_id: 'Communicated', item_text: 'Communicated' , probability: 50, disabled: true},
      { item_id: 'Pending', item_text: 'Pending' , probability: 10, disabled: true},
    ];
    }

    
this.dropdownSettings = {
  singleSelection: false,
  idField: 'item_id',
  textField: 'item_text',
  // Remove these two lines completely
  // selectAllText: 'Select All',
  // unSelectAllText: 'UnSelect All',
  itemsShowLimit: 3,
  allowSearchFilter: true,
  allowSelectAll: false, // can remove this too if unsupported
  enableCheckAll: false
};

    if(this.formAction === 'Update') {
      this.pipelineName = this.updateData.pipeline_name;
      this.selectedItems = this.updateData.stages.map((stage: any) => {
        return {
          item_id: stage.stage_name,
          item_text: stage.stage_name
        };
      });

      let newStages = this.updateData.stages.map((stage: any) => {
        return {
          item_id: stage.stage_name,
          item_text: stage.stage_name,
          probability: stage.probability
        };
      }
      );

      this.stages = this.stages.concat(newStages);

      // remove duplicates

      this.stages = this.stages.filter((stage, index, self) =>
        index === self.findIndex((t) => (
          t.item_id === stage.item_id
        ))
      );

      console.log('Updated Stages:', this.stages);


    }
  
  }
  

  pipelineName: string = '';

  selectedStages: Array<any> = [];


  // Variables for new stage modal
  newStageName: string = '';
  newStageProbability: number | null = null;

  savePipeline(isValid: any): void {
    if (isValid) {
      console.log("stages",this.stages)
      console.log('Pipeline Name:', this.pipelineName);
      console.log('Selected Stages:', this.selectedItems);

      this.btnLoading = true;

      const updatedStages = this.selectedItems.map((stage: any) => {
        return {
          stage_name: stage.item_id,
          probability: this.stages.find((s: any) => s.item_id === stage.item_id).probability
        };
      });
      
      const payload:any = {
        pipeline_name: this.pipelineName,
        stage_status: 'Active',
        client_id: this.localStorage.getClientId(),
        stages: updatedStages,
        set_default: false,
        pipeline_type: this.selectedTab,
      };

     
      if(this.formAction === 'Update'){

        payload['pipeline_id'] = this.updateData.pipeline_id;

        this.api.updatePipeLine(payload).subscribe({
          next: (res: any) => {
            console.log('Update Pipeline Response:', res);
            this.toast.success('Pipeline updated successfully');
            this.tracker.track("Update", "Pipeline", `Updated pipeline: ${this.pipelineName}`);

            this.closeModal();
            this.reload.emit();
          },
          error: (err: any) => {
            console.error('Update Pipeline Error:', err);
            this.toast.error('Failed to update pipeline');
            this.btnLoading = false;
          }
        });

        
      }else{
        this.api.createPipeLine(payload).subscribe({
          next: (res: any) => {
            console.log('Create Pipeline Response:', res);
            this.toast.success('Pipeline created successfully');
            this.tracker.track("Create", "Pipeline", `Created pipeline: ${this.pipelineName}`);

            this.closeModal();
            this.reload.emit();
          },
          error: (err: any) => {
            console.error('Create Pipeline Error:', err);
            this.toast.error('Failed to create pipeline');
            this.btnLoading = false;
          }
        });
      }

    }
  }

  openAddStageModal(content: any): void {

    this.modalService.open(content, { size: 'md', scrollable: true, centered: true, backdrop: 'static', keyboard: false });

  }

  onItemSelect(item: any) {
    console.log("item",item);
  }
  onSelectAll(items: any) {
    // this.selectedItems = items;
    console.log('Selected Items:', this.selectedItems);
  }

  addStage(event: any): void {
    console.log('Event:', event);
    this.newStageName = event.item_id;
    this.newStageProbability = event.probability;

    console.log('New stage added:', this.newStageName, this.newStageProbability);
    if (this.newStageName && this.newStageProbability !== null && this.newStageProbability !== null) {
      const newStage = {
        item_id: `${this.newStageName}`,
        item_text: `${this.newStageName}`,
        probability: this.newStageProbability
      };

      // Add the new stage and assign a new array reference
      this.stages = [...this.stages, newStage];
      this.tracker.track("Create", "Pipeline Stage", `Added new stage: ${newStage.item_text} with ${newStage.probability}% probability`);


  

      console.log('New stage added:', this.stages);

      // Clear the input fields
      this.newStageName = '';
      this.newStageProbability = null;

      // Close the modal
    } else {
      this.toast.error('Please enter a valid stage name and probability');
    }
  }

  // openForecastModal(content: any): void {
  //   this.modalService.open(content, {
  //     size: 'lg',
  //     centered: true,
  //     scrollable: true,
  //     backdrop: 'static',
  //     keyboard: false,
  //   });
  // }


}
